import { render, staticRenderFns } from "./rene-rostaing.vue?vue&type=template&id=70734a04&scoped=true"
import script from "./rene-rostaing.vue?vue&type=script&lang=js"
export * from "./rene-rostaing.vue?vue&type=script&lang=js"
import style0 from "./rene-rostaing.vue?vue&type=style&index=0&id=70734a04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70734a04",
  null
  
)

export default component.exports